import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

export const BASE = {
    path: `${ptlEnvs.base}/elctdoc/rcpn`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/elctdoc/rcpns`,
};

export const URLS = {
    ptli0701001q: `${BASE.path}/ptli0701001q`,
    ptli0701002q: `${BASE.path}/ptli0701002q`,
};

export const APIS = {
    // Get a list of Receive electronic documents. !== 전자문서 수신 목록을 조회한다. ==!
    getElctDocRcpnList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Select Receive electronic documents details !== 전자문서 수신 상세 정보 조회 ==!
    getElctDocRcpn: (trscLogId: any) => {
        return api.get(`${BASE.api}/${trscLogId}`);
    },
    // Update sending electronic documents !== 전자문서 수신 수정 ==!
    updateElctDocRcpn: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Get a list of Receive electronic documents. !== 전자문서 수신 목록을 조회한다. ==!
    getResdHistList: (data: any, page: number, size: number) => {
        return api.post(`${BASE.api}/resdHist?page=${page}&size=${size}`, {
            ...data,
        });
    },
};

export const SF_DOC_RCPN_MGMT_SRCH: TFormSchema = {
    id: "form_docRcpnMgmtSrch",
    schema: {
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        sndrcvTpCd: {
            type: "select",
            label: "L_SNDRCV_TP_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0070",
        },
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_REFF_NO", value: "A" },
                { label: "L_SNDR_ID", value: "B" },
                { label: "L_INTF_ID", value: "C" },
                { label: "L_TRSC_LOG_ID", value: "D" },
                { label: "L_UCR_NO", value: "E" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
        startTimeRnge: {
            type: "daterange",
            label: "L_RGSR_DT",
            start: { name: "startFrstRgsrDtm" },
            end: { name: "endFrstRgsrDtm" },
            rangeButton: 5,
        },
        intfSttsCd: {
            type: "select",
            label: "L_PRCSS_STAT",
            all: true,
            area: "comnCd",
            comnCd: "COM0068",
        },
        sndrcvDvnCd: {
            type: "select",
            label: "L_SNDRCV_DVN_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0077",
        },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            area: "comnCd",
            comnCd: "COM0024",
            required: true,
        },
    },
};

export const SG_DOC_RCPN_MGMT_LIST: TGridSchema = {
    id: "grid_docRcpnMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TRSC_LOG_ID", binding: "trscLogId", width: "18%" }] },
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "*" }] },
        { cells: [{ header: "L_SNDRCV_TP_NM", binding: "sndrcvTpCdNm", width: "13%" }] },
        { cells: [{ header: "L_SNDR_ID", binding: "intfSndrId", width: "*" }] },
        { cells: [{ header: "L_REFF_NO", binding: "coReffNo", width: "*" }] },
        { cells: [{ header: "L_UCR_NO", binding: "ucrNo", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "*" }] },
        { cells: [{ header: "L_PRCSS_STAT", binding: "intfSttsCdNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "trscLogId" }] },
        { cells: [{ binding: "intfId" }] },
        { cells: [{ binding: "sndrcvTpCdNm" }] },
        { cells: [{ binding: "intfSndrId" }] },
        { cells: [{ binding: "coReffNo", align: "left" }] },
        { cells: [{ binding: "ucrNo", align: "left" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
        { cells: [{ binding: "intfSttsCdNm" }] },
    ],
};

export const SG_RESD_HIST_LIST: TGridSchema = {
    id: "grid_resdHistList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TRSC_LOG_ID", binding: "trscLogId", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "*" }] },
        { cells: [{ header: "L_PRCSS_STAT", binding: "intfSttsCdNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "trscLogId" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
        { cells: [{ binding: "intfSttsCdNm" }] },
    ],
};

export const SF_DOC_RCPN_MGMT_INFO: TFormSchema = {
    id: "form_docRcpnMgmtInfo",
    schema: {
        trscLogId: { type: "text", label: "L_TRSC_LOG_ID", edit: false },
        intfId: { type: "text", label: "L_INTF_ID", edit: false },
        trscId: { type: "text", label: "L_TRSC_ID", edit: false },
        intfSndrId: { type: "text", label: "L_SNDR_ID", edit: false },
        coReffNo: { type: "text", label: "L_REFF_NO", edit: false },
        ucrNo: { type: "text", label: "L_UCR_NO", edit: false },
        intfSttsCd: { type: "text", label: "L_PRCSS_STAT", edit: false },
        intfSttsCdNm: { type: "text", label: "L_PRCSS_STAT", edit: false },
        frstRgsrDtm: { type: "datetime", label: "L_FRST_RGSR_DTM", edit: false },
        intfRsltErrCn: { type: "textarea", label: "L_ERR_MSG_CN", edit: false },
        htphdCn: { type: "textarea", label: "L_HTPHD_CN", edit: false },
        msgOrgnCn: { type: "textarea", label: "L_MSG_ORGN_CN", edit: false },
        msgAckCn: { type: "textarea", label: "L_MSG_ACK_CN", edit: false },
    },
};

export const SF_MSG_INFO: TFormSchema = {
    id: "form_msgInfo",
    schema: {
        msg: { type: "textarea", label: "L_MSG_CN", edit: false },
    },
};
